import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

export const container = css`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const text = css`
  color: var(${DesignToken.ContentBasicPrimary});
  margin: var(${SpacingToken.Spacing8}) 0 2px;
`;
